/**
 * Checks if the dateFrom for the product is set,
 * for a product that is a seasonal product (like Unlimited passes)
 *
 * If not, fetch the dates from an offer and apply.
 */
export default defineNuxtRouteMiddleware(async (to) => {
    const { product } = useProduct<ProductActivity>(to);

    if (!product.value.dateFrom && product.value.config.isUsingSeasonDates) {
        try {
            const { data: { dateFrom, dateUntil } } = await apiLoadActivitySeasonDates(
                product.value.activityId,
                product.value.config.defaultPassengerAge,
                product.value.promotion,
            );
            product.value.dateFrom = dateFrom;
            product.value.dateUntil = dateUntil;
        }
        catch (error) {
            throw createError({
                fatal: true,
                status: 500,
                message: (error as Error)?.message,
                cause: error,
            });
        }
    }
});
